import React, { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { Button, Menu, message } from "antd";
import CertificationTable from "./certifications/CertificationTable";
import DetailsTable from "./details/DetailsTable";
import Instance from "../../AxiosConfig";
import { Documents } from "./details/Documents";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { NdaDocuments } from "./details/NdaDocuments";
import { SlaDocuments } from "./details/SlaDocuments";
import { Proposal } from "./details/Proposal";
import { Content } from "./details/Content";
const ComapanyDataCertification = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { id } = useParams();
  const [companyData, setCompanyData] = useState({});
  const [loading, setLoading] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const fetchCompanyDetails = async () => {
    setLoading(true);
    try {
      const response = await Instance.get(`/company/${id}`);

      if (response.status === 200 || response.status === 201) {
        console.log("Company Details:", response.data);
        setCompanyData(response.data);
      }
    } catch (error) {
      console.error("Error fetching company details:", error);
      message.error("Failed to load company details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchCompanyDetails();
  }, [id]);

  const items = [
    {
      label: "Invoices",
      key: "invoices",
    },

    {
      label: "Details",
      key: "details",
    },
    {
      label: "Documents",
      key: "documents",
    },
    {
      label: "NDA",
      key: "nda",
    },
    {
      label: "SLA",
      key: "sla",
    },
    {
      label: "Proposal",
      key: "proposal",
    },
    {
      label: "Additional Information",
      key: "content",
    },
  ];

  const [current, setCurrent] = useState("invoices");

  const onClick = (e) => {
    setCurrent(e.key);
  };

  return (
    <>
      <div className="details-page">
        <div className="detials-page-heading">
          <div className="detials-page-heading-content">
            <h2>{companyData.companyName}</h2>
          </div>
        </div>
      </div>
      <div className="setting-access mt-5">
        <div className="settings-access-container">
          <div className="tabs-header d-flex align-items-center justify-content-between ">
            <div className="nav-menu-wrapper">
              <Menu
                onClick={onClick}
                selectedKeys={[current]}
                mode="horizontal"
                items={items}
                className="settings-access-menu"
              />
            </div>

            <Button
              type="default"
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate(-1)}
              className="add-certification-btn"
            >
              Back
            </Button>
          </div>
          <div className="tab-content">
            {current === "invoices" && (
              <CertificationTable companyData={companyData} />
            )}
            {current === "details" && (
              <DetailsTable companyData={companyData} />
            )}
            {current === "documents" && <Documents companyData={companyData} />}
            {current === "nda" && <NdaDocuments companyData={companyData} />}
            {current === "sla" && <SlaDocuments companyData={companyData} />}
            {current === "content" && <Content companyData={companyData} />}
            {current === "proposal" && <Proposal companyData={companyData} />}
          </div>
        </div>
      </div>
    </>
  );
};

export default ComapanyDataCertification;
